<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';

import { TooltipProvider } from '@/components/ui/tooltip';
import AppToaster from '@components/atoms/AppToaster.vue';
import AuthTemplate from '@components/templates/AuthTemplate.vue';
import DefaultTemplate from '@components/templates/DefaultTemplate.vue';
import PortalTemplate from '@components/templates/PortalTemplate.vue';

const route = useRoute();

/**
 * The two routes that render outside the application shell: the login screen,
 * and the contractor portal, whose visitors have no session for the sidebar and
 * header to describe.
 */
const layout = computed(() => {
  if (route.path === '/login') {
    return AuthTemplate;
  }

  if (route.path === '/portal') {
    return PortalTemplate;
  }

  return DefaultTemplate;
});
</script>

<template>
  <TooltipProvider :delay-duration="200" :skip-delay-duration="300">
    <component :is="layout">
      <RouterView v-slot="{ Component }">
        <Transition name="fade" mode="out-in">
          <component :is="Component" />
        </Transition>
      </RouterView>
    </component>
    <AppToaster />
  </TooltipProvider>
</template>
